import styles from "./how-it-began.module.scss";
import Image from "next/image";
import animations from "@components/shared/animation/animations.module.scss";
import SharedAnimation from "@components/shared/animation";

 interface ServiceSection {
  title: string;
  iconUrl: string;
  content: string[];
}

type ServiceCardsProps = {
  section: ServiceSection;
};

const HowItBegan = ({ section }: ServiceCardsProps): JSX.Element => {
  return (
    <SharedAnimation
      render={(ref) => (
        <div
          ref={ref}
          className={`${styles.container} ${animations.scroll__animation}`}
        >
          <section className={`${styles.section}`}>
            <div className={styles.section__block}>
              <div className={styles.section__block__image}>
                <Image
                  src={section.iconUrl}
                  layout={"fill"}
                  objectFit={"contain"}
                  loading="eager"
                  alt={section.title}
                  className={styles.icon__image}
                />
              </div>
              <div className={styles.section__block__item}>
                <h3 className={styles.section__block__item__title}>
                  {section.title}
                </h3>
                {section.content.map((text: any, idx: any) => (
                  <p key={idx} className={styles.section__block__item__text}>
                    {text}
                  </p>
                ))}
              </div>
            </div>
          </section>
        </div>
      )}
    />
  );
};

export default HowItBegan;
